import axios from 'axios';
// config
import { HOST_API, } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
});

// Request interceptor - restore Authorization header on every request
axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = window.localStorage.getItem('accessToken');
    if (accessToken && accessToken !== 'undefined' && accessToken !== 'null') {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,

  (error) => {
    // Only treat as session expired if it's an auth/account endpoint returning 401
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const isAuthEndpoint = url.includes('/api/account/') || url.includes('/api/login/') || url.includes('/api/register');

      if (isAuthEndpoint) {
        localStorage.removeItem('accessToken');
        localStorage.clear();
        if (!window.location.pathname.includes('/auth/login')) {
          window.location.href = '/auth/login';
        }
      }
      // For non-auth 401s (e.g. purchase endpoints), just reject — don't log out the user
    }

    const message = (error.response && error.response.data && (error.response.data.message || error.response.data.error || JSON.stringify(error.response.data))) || error.message || 'Something went wrong';
    return Promise.reject({ message });
  }
);


export default axiosInstance;
